import "../../styles/projects.css"
import { useSelector, useDispatch } from "react-redux"
import { dateFormat } from "../../classes/utils"
import { useEffect, useState } from "react"
import { Project, Spinner } from "../components"
import { getNumberOfColumnsInTable } from "../../classes/dom.utils"
import LocalMetrics from "../../classes/LocalMetrics"
import MetricsDataFormatter from "../../classes/MetricsDataFormatter"

function Projects() {
    const dispatch = useDispatch()
    const [ colSpan, setColSpan] = useState(0)
    const [ previousFilter, setPreviousFilter ] = useState("")
    const { isPending } = useSelector((state) => state.fetchStatus)
    const { projects, searchFilter } = useSelector((state) => state.projects)
    const projectsFiltered = searchFilter ? projects.filter(({projectUrl}) => projectUrl.includes(searchFilter)): projects
    if( previousFilter != searchFilter && searchFilter.length) {
        const formatter = new MetricsDataFormatter()
        const projectFormattedData = formatter.format({projects: projectsFiltered})
        const localMetrics = new LocalMetrics()
        localMetrics.update(projectFormattedData, dispatch, "filteredOverview")
        setPreviousFilter(searchFilter)
    }


    const tableColumns = [ 
        { columnName: "Project Name", accessorKey: "projectUrl", id: "th-project"},
        { columnName: "Branch", accessorKey: "projectBranch", id: "th-branch"},
        { columnName: "Vulnerabilities", accessorKey: "vulns", id: "th-vulns"},
        { columnName: "Total scans", accessorKey: "totalScans", id: "th-total-scans"},
        { columnName: "Security score", accessorKey: "securityScore", id: "th-security-score"},
        { columnName: "Last scanned", accessorKey: "lastScanned", id: "th-last-scan"}
    ]
    const handleResize = () => {
        setColSpan(getNumberOfColumnsInTable(".projects-table > table"))
    }

    useEffect(() => {
        handleResize()
        window.addEventListener("resize", handleResize)
    }, [])
    return (
        <div className="flex flex-col justify-center">
            <div className="table-header mt-5">
            </div>
            <div className="projects-table table-body mt-5 overflow-auto shadow-md">
                <table className="table-auto rounded-sm ">
                    <thead className="text-left">
                        <tr>
                            {tableColumns.map(({ columnName, id }, index) => {
                                
                                return <th key={columnName+"head"} id={id} width={!index ? "35%": ""} className={`text-lg ${index && "text-center"}`}>{columnName}</th>
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {isPending && <tr><td colSpan={6} className=""><Spinner position={"center"}/></td></tr>}
                        {!projectsFiltered.length  && !isPending && <tr id="no-projects-found"><td className="text-lg text-center" colSpan={6}>no projects found</td></tr>}
                        {projectsFiltered.length && !isPending?
                            projectsFiltered.map((project, i) => {
                                const projectModefied = projectDateModified(project)
                                return <Project key={project.projectUrl+i} project={projectModefied} tableColumns={tableColumns} colSpan={colSpan}></Project>
                            }): ""
                        }
                    </tbody>
                </table>
            </div>
            <div className="table-footer">
                {/* <h1>pagination</h1> */}
            </div>
        </div>
    )
}

const projectDateModified = (project) => {
    const projectModefied = {...project}
    projectModefied.lastScanned = dateFormat(project.scans[project.scans.length-1].timestamp)
    projectModefied.vulns = project.vulnerabilitiesIdentified
    projectModefied.totalScans = project.scans.length
    projectModefied.securityScore = project.scans[project.scans.length - 1].securityScore
    return projectModefied
}

export default Projects